import React from 'react';

const OrganizationSchema = () => {
  // Get dynamic base URL for deployment flexibility
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://legaldocspecialist.com';
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Legal Document Specialist",
    "alternateName": ["LDS", "Legal Document Specialist California"],
    "description": "Riverside County's premier legal document service provider. Specializing in process serving, court filing, and document retrieval with 22+ years local experience.",
    "url": baseUrl,
    "telephone": "(760) 866-9182",
    "email": "support@legaldocspecialist.com",
    "foundingDate": "2003",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "225 South Civic Drive, Ste 2-16",
      "addressLocality": "Palm Springs",
      "addressRegion": "CA",
      "postalCode": "92262",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "33.8303",
      "longitude": "-116.5453"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "(760) 866-9182",
        "contactType": "customer service",
        "areaServed": "California",
        "availableLanguage": ["English"],
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "17:00"
        }
      },
      {
        "@type": "ContactPoint",
        "email": "support@legaldocspecialist.com",
        "contactType": "customer service",
        "areaServed": "California"
      }
    ],
    "areaServed": [
      {
        "@type": "State",
        "name": "California"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Riverside County"
      },
      {
        "@type": "AdministrativeArea", 
        "name": "San Bernardino County"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Imperial County"
      },
      {
        "@type": "City",
        "name": "Temecula"
      },
      {
        "@type": "City",
        "name": "Murrieta"
      },
      {
        "@type": "City",
        "name": "Menifee"
      },
      {
        "@type": "City",
        "name": "Sky Valley"
      },
      {
        "@type": "City",
        "name": "Mecca"
      },
      {
        "@type": "City",
        "name": "Pioneertown"
      }
    ],
    "serviceType": [
      "Process Serving",
      "Court Filing", 
      "E-Filing",
      "Document Retrieval",
      "Skip Tracing",
      "County Recording",
      "Same Day Process Serving",
      "Rush Service",
      "Legal Document Services"
    ],
    "slogan": "Professional Legal Document Services Throughout California",
    "knowsAbout": [
      "California Process Serving Laws",
      "Court Filing Procedures",
      "Electronic Filing Systems",
      "Legal Document Service",
      "Skip Tracing Techniques",
      "Document Retrieval Processes"
    ],
    "memberOf": [
      {
        "@type": "Organization",
        "name": "California Association of Legal Document Assistants"
      }
    ],
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "License",
        "name": "Registered Process Server",
        "issuedBy": {
          "@type": "Organization",
          "name": "County of Riverside"
        }
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    },
    "paymentAccepted": ["Cash", "Credit Card", "Check", "Invoice"],
    "currenciesAccepted": "USD",
    "openingHours": "Mo-Fr 09:00-17:00",
    "specialOpeningHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "opens": "00:00",
        "closes": "23:59",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "validFrom": "2025-01-01",
        "validThrough": "2025-12-31",
        "name": "Emergency Service Available 24/7"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Legal Document Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Routine Process Serving",
            "description": "Standard process serving within 4 business days"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service", 
            "name": "Same Day Process Serving",
            "description": "Urgent same-day process serving throughout California"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Court E-Filing",
            "description": "Electronic filing services for California courts"
          }
        }
      ]
    },
    "sameAs": [
      baseUrl,
      "https://legaldocspecialist.legalconnect.com"
    ]
  };

  React.useEffect(() => {
    // Add Organization Schema to page
    const existingOrgSchema = document.querySelector('#organization-schema-data');
    if (existingOrgSchema) {
      existingOrgSchema.remove();
    }
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'organization-schema-data';
    script.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(script);

    return () => {
      const schemaElement = document.querySelector('#organization-schema-data');
      if (schemaElement) {
        schemaElement.remove();
      }
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default OrganizationSchema;